/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { AccessEligibilityMetadata } from "./AccessEligibilityMetadata";
import type { PartnerMatchingRequestMetadata } from "./PartnerMatchingRequestMetadata";
import type { ProgressionStep } from "./ProgressionStep";
import type { VisitOptionSelectionMetadata } from "./VisitOptionSelectionMetadata";

export interface AdvanceProgressionRequest {
  /** The step being completed */
  step_id: ProgressionStep;
  /** Optional step-specific metadata */
  metadata?:
    | VisitOptionSelectionMetadata
    | PartnerMatchingRequestMetadata
    | AccessEligibilityMetadata
    | null;
}
